<script setup lang="ts">
defineProps({
	actionCount: {
		type: Number,
		default: 2,
	},
});

const { isMobile } = useWindowResize();
</script>

<template>
  <div
    class="loader-profile-details"
  >
    <MultipleSkeletonLoader
      :rows="actionCount"
      is-row-direction
    >
      <TextInputSkeletonLoader
        height="12"
        :width="isMobile ? '100px' : '200px'"
      />
    </MultipleSkeletonLoader>
    <ParagraphSkeletonLoader />
  </div>
</template>

<style scoped lang="scss">
.loader-profile-details {
  width: 100%;
	display: grid;
	gap: spacings-get(6);
  margin-top: spacings-get(2);
}
</style>